var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusConnectWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 704.4 706.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206,150.7H87.3C39.1,150.7,0,189.8,0,238v0c0,48.2,39.1,87.3,87.3,87.3H206c27.9,73.6,90.1,130.3,167.1,150.7v-44.4 c-53.4-17.4-97-56.2-120.8-106.3c-12.6-26.5-19.6-56.1-19.6-87.3s7.1-60.9,19.6-87.3c23.8-50.1,67.5-88.9,120.8-106.3V0 C296.1,20.4,233.9,77.1,206,150.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.1,150.7H666.5C638.6,77.1,576.4,20.4,499.4,0v44.4c53.4,17.4,97,56.2,120.8,106.3c12.6,26.5,19.6,56.1,19.6,87.3 s-7.1,60.9-19.6,87.3c-23.8,50.1-67.5,88.9-120.8,106.3v44.4c77-20.4,139.2-77.1,167.1-150.7h118.6c48.2,0,87.3-39.1,87.3-87.3v0 C872.4,189.8,833.3,150.7,785.1,150.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.3,80.2L429.3,80.2c-21.2,0-38.4,17.2-38.4,38.4v145.8c0,21.2,17.2,38.4,38.4,38.4h0c21.2,0,38.4-17.2,38.4-38.4V118.6 C467.7,97.4,450.5,80.2,429.3,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.3,319.1L429.3,319.1c-21.2,0-38.4,17.2-38.4,38.4v0c0,21.2,17.2,38.4,38.4,38.4h0c21.2,0,38.4-17.2,38.4-38.4v0 C467.7,336.3,450.5,319.1,429.3,319.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusConnectWarningIcon);
export default __webpack_public_path__ + "static/media/status-connect-warning-icon.55dfe86a23ed6c5a3c05cad7fb09fd10.svg";
export { ForwardRef as ReactComponent };